module.exports = __webpack_public_path__ + "static/media/digi3.27dd9438.jpg";